/**
 * 「スタジオができるまで」── 防音スタジオ工事の記録データ
 *
 * ■ 工程を追加するとき（全5工程）
 *   buildPhases 配列に、1工程分のオブジェクトを足すだけです。
 *   配列の順番がそのまま表示順・STEP番号（1 → 5）になります。
 *
 * ■ 写真を差し替えるとき
 *   各工程の photos 配列の中の src を、実際の写真URLに置き換えるだけです。
 *   photos は「1件 = 1枚」。追加・削除も自由です。
 *
 * ■ 注釈（写真のひとことメモ）を入れるとき
 *   photo.caption に文章を書くと、写真の下に表示されます。
 *   空欄（''）のままなら何も表示されません。
 */

export interface BuildPhoto {
  /** 写真URL ※実写真に差し替える場合はここだけ変更 */
  src: string;
  /** 代替テキスト */
  alt: string;
  /** 写真の注釈／ひとこと（'' なら非表示） */
  caption: string;
}

export interface BuildPhase {
  /** 一意なID（変更不要） */
  id: string;
  /** 工程番号（1〜5） */
  step: number;
  /** 見出し */
  title: string;
  /** 短い一言コピー */
  lead: string;
  /** この工程の写真たち */
  photos: BuildPhoto[];
}

/** 全工程数（見出しの「1 / 5」表示に使用） */
export const BUILD_TOTAL_PHASES = 5;

export const buildPhases: BuildPhase[] = [
  {
    id: 'phase-1',
    step: 1,
    title: '搬出 ― 空っぽになった部屋',
    lead:
      '荷物が運び出され、空っぽになった部屋。寂しさより先に浮かんだのは、期待でした。この場所から、これからどんな音が生まれていくんだろう。',
    photos: [
      {
        src: '/images/studio-build/img-1796.jpg',
        alt: '荷物が運び出され、空っぽになった部屋（IMG_1796）',
        caption: '',
      },
      {
        src: '/images/studio-build/img-1794.jpg',
        alt: 'トラックに荷物を積み込み、搬出する様子（IMG_1794）',
        caption: '',
      },
      {
        src: '/images/studio-build/img-1791.jpg',
        alt: '搬出の作業風景（IMG_1791）',
        caption: '',
      },
      {
        src: '/images/studio-build/img-1747.jpg',
        alt: 'コンセントの電気工事（IMG_1747）',
        caption: '電気工事士の免許を利用して、コンセントの電気工事を事前に行った',
      },
    ],
  },
];
